/**
 * Test IDs for QA automation.
 */
export const testIds = {
  tripLinkOpen: "trip-link-open",
} as const;
